/**
 * SectionTitle component module.
 * @module shared/components/SectionTitle
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

const _Label = styled.div`
  color: ${(props) => props.theme.dark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)'};
  font-family: ${(props) => props.theme.titleText.name};
  font-size: ${props => props.theme.titleText.size.replace('px', '') - 2}px;
  margin-bottom: 2px;
  width: 100%;
  width: -moz-available;
  //noinspection CssInvalidPropertyValue
  width: -webkit-fill-available;
  //noinspection CssInvalidPropertyValue
  width: fill-available;
  //noinspection CssInvalidPropertyValue
  width: stretch;
  overflow-wrap: break-word;
  text-align: left;
`;

const _Divider = styled.hr`
  background-color: ${(props) => props.theme.dark ? 'rgba(255, 255, 255, 0.25)' : 'rgba(0, 0, 0, 0.25)'};
  border-width: 0px;
  height: 1px;
  width: 100%;
  width: -moz-available;
  //noinspection CssInvalidPropertyValue
  width: -webkit-fill-available;
  //noinspection CssInvalidPropertyValue
  width: fill-available;
  //noinspection CssInvalidPropertyValue
  width: stretch;
  margin-top: 0px;
`;

const _SectionTitleBase = styled.div`
  margin: 5px;
  width: 100%;
  width: -moz-available;
  //noinspection CssInvalidPropertyValue
  width: -webkit-fill-available;
  //noinspection CssInvalidPropertyValue
  width: fill-available;
  //noinspection CssInvalidPropertyValue
  width: stretch;
`;

const SectionTitle = (props) => {
  const {title} = props;
  return (
    <_SectionTitleBase>
      <_Label>{title}</_Label>
      <_Divider/>
    </_SectionTitleBase>
  );
};

export default SectionTitle;

SectionTitle.propTypes = {
  /**
   * Title of the Section Title
   */
  title: PropTypes.string.isRequired,
};
